import "emoji-picker-element";
import { useEffect, useRef } from "react";

const Emoji = ({ handleEmojiClick, closeEmojiPicker }) => {
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        closeEmojiPicker();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeEmojiPicker]);

  return (
    <emoji-picker
      class="dark"
      style={{
        "--num-columns": 5, // 5 emojis per row
        width: "calc(var(--emoji-size, 32px) * 11)", // Adjust height for 4 rows
        height: "calc(var(--emoji-size, 32px) * 10)", // Adjust height for 4 rows
        overflowY: "auto", // Enable vertical scrolling
        borderRadius: "0.3rem", // Apply border-radius
        "--category-emoji-size": "1.15rem",
        "--emoji-size": "1.35rem",
        "--category-emoji-padding": "0.15rem",
        "--emoji-padding": "0.25rem",
      }}
      ref={(picker) => {
        emojiPickerRef.current = picker;
        if (picker && !picker.hasListener) {
          picker.addEventListener("emoji-click", handleEmojiClick);
          picker.hasListener = true;

          // Remove the element with the class name 'search-row'
          const searchRowElement =
            picker.shadowRoot?.querySelector(".search-row");
          if (searchRowElement) {
            searchRowElement.style.display = "none";
          }
        }
      }}
    ></emoji-picker>
  );
};

export default Emoji;
